import type {
  VehicleHandoverDestination,
  VehicleHandoverType,
} from "./vehicleHandover";
import {
  DEFAULT_HANDOVER_STATUS_FILTER,
  handoverDestinationOptions,
  handoverStatusFilterOptions,
  type VehicleHandoverStatusFilter,
} from "./vehicleHandoverLabels";

export interface VehicleHandoversSearch {
  readonly page: number;
  readonly status: VehicleHandoverStatusFilter;
  readonly destination?: NonNullable<VehicleHandoverDestination>;
  readonly type?: VehicleHandoverType;
  readonly overdue?: boolean;
  readonly followUpPending?: boolean;
  readonly followUpOverdue?: boolean;
  readonly swap?: boolean;
}

export const handoverTypeOptions = [
  { value: "issue", label: "Uitgifte" },
  { value: "return", label: "Inname" },
  { value: "delivery", label: "Levering" },
] as const;

export function handoverTypeLabel(type: VehicleHandoverType): string {
  return (
    handoverTypeOptions.find((option) => option.value === type)?.label ?? type
  );
}

export const booleanFilterOptions = [
  { value: "true", label: "Ja" },
  { value: "false", label: "Nee" },
];

export function parseBooleanFilter(value: unknown): boolean | undefined {
  if (value === true || value === "true") return true;
  if (value === false || value === "false") return false;
  return undefined;
}

/** Explicit undefined values clear invalid raw URL parameters on router merge. */
export function parseVehicleHandoversSearch(
  search: Record<string, unknown>,
): VehicleHandoversSearch {
  const page = Number(search.page);
  return {
    page: Number.isInteger(page) && page >= 1 ? page : 1,
    status: handoverStatusFilterOptions.some(
      (option) => option.value === search.status,
    )
      ? (search.status as VehicleHandoverStatusFilter)
      : DEFAULT_HANDOVER_STATUS_FILTER,
    destination: handoverDestinationOptions.some(
      (option) => option.value === search.destination,
    )
      ? (search.destination as NonNullable<VehicleHandoverDestination>)
      : undefined,
    type: handoverTypeOptions.some((option) => option.value === search.type)
      ? (search.type as VehicleHandoverType)
      : undefined,
    overdue: parseBooleanFilter(search.overdue),
    followUpPending: parseBooleanFilter(search.followUpPending),
    followUpOverdue: parseBooleanFilter(search.followUpOverdue),
    swap: parseBooleanFilter(search.swap),
  };
}
